import { useEffect, useMemo, useState } from "react";
import _ from "lodash";

import Box from "components/Box";
import Image from "components/Image";
import Stack from "components/Stack";

import { checkFilePermission } from "entities/Field/sdk";
import SectionContent from "entities/Memo/components/Sections/SectionContent";
import SectionHeader from "entities/Memo/components/Sections/SectionHeader";
import { IMemoSection } from "entities/Memo/sdk";

interface IPrintableSectionImage {
  section: IMemoSection;
}

const PrintableSectionImage = ({ section }: IPrintableSectionImage) => {
  const [imageUrl, setImageUrl] = useState<string>();

  const imageId = useMemo(() => {
    if (
      section.fields &&
      section.fields[0].values &&
      section.fields[0].values.length > 0 &&
      section.fields[0].values[0].file
    ) {
      return section.fields[0].values[0].file.id;
    }

    return null;
  }, [section]);

  useEffect(() => {
    const fieldId = _.first(section.fields)?.company_custom_field_id;

    if (!_.isNull(imageId) && !_.isNil(fieldId)) {
      checkFilePermission({
        fileId: imageId,
        fieldId,
      }).then(({ url }) => {
        setImageUrl(url);
      });
    }
  }, [imageId, section]);

  return (
    <Box data-testid="image-section">
      <SectionHeader label={section.title} alignActionButton="right" />
      <SectionContent breakInside="avoid">
        <Box
          sx={{
            breakInside: "avoid",
          }}
        >
          {imageUrl && (
            <Stack spacing={2}>
              <Image
                src={imageUrl}
                className={
                  section.limit_image_section_height
                    ? ""
                    : "unlimited-height-image"
                }
                sx={{
                  ...(section.limit_image_section_height
                    ? {
                        height: "460px",
                        objectFit: "cover",
                      }
                    : {
                        height: "100%",
                        maxHeight: "100vh",
                        breakInside: "avoid",
                      }),
                  width: "100%",
                }}
                imageDataTestid="uploaded-image"
              />
            </Stack>
          )}
        </Box>
      </SectionContent>
    </Box>
  );
};

export default PrintableSectionImage;
